import { useQuery } from '@tanstack/react-query';
import { size } from 'lodash';
import { useEffect } from 'react';
import getInvoices from '../../api/queries/getInvoices';
import { setInvoices } from '../../redux/data/dataSlice';
import { useAppDispatch } from '../../redux/hooks';
import { store } from '../../redux/store';

const useData = () => {
  const user = store.getState().auth.user;
  const invoices = store.getState().data.invoices;

  const { data, isLoading, isStale, isSuccess, error, refetch } = useQuery({
    queryKey: ['getInvoices'],
    enabled: !!user && size(invoices) == 0,
    queryFn: () => getInvoices(),
  });

  return {
    // Modifiers
    data,
    isLoading,
    isStale,
    isSuccess,
    error: error,
    refetch,
  };
};

const useInovoicesStoreSetter = () => {
  const { data, refetch, isLoading, isStale, isSuccess } = useData();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data && isSuccess && isStale) {
      dispatch(setInvoices(data));
    }
  }, [isSuccess, data]);

  return { data, isLoading, refetch };
};

export { useInovoicesStoreSetter };
